import { MIN_STUDENT_AGE } from "../utils/config";

/**
 * 年度末年齢計算
 * @param {string} birthday_val
 * @returns {number}
 */
export const calcEndOfYearAge = (birthday_val) => {
  const birthday = new Date(birthday_val);
  // 年度末日付取得
  const today = new Date();
  // 1～3月 ⇒ 今年の3/31、4～12月 ⇒ 来年の3/31
  const eofy_date = new Date(
    today.getMonth() < 3 ? today.getFullYear() : today.getFullYear() + 1,
    3 - 1,
    31
  );
  // 1～3月生まれ ⇒ 誕生日が来ているので特に何もしない
  // 4～12月生まれ ⇒ まだ誕生日が来ていないのでさらに1引く
  const eofy_age =
    eofy_date.getFullYear() -
    birthday.getFullYear() -
    (birthday.getMonth() < 3 ? 0 : 1);

  return eofy_age;
};

/**
 * 年度末時点で55歳の人の誕生年の1/1の日付を取得
 * @returns {string}
 */
export const getDefaultCalendar = () => {
  const today = new Date();
  return String(today.getFullYear() - MIN_STUDENT_AGE) + "-01-01";
};
